import { IonSkeletonText, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { CHOSEN_CORE_VALUES_LIMIT } from "@/lib/constants";
import { queryOptions_coreValuesChosen } from "@/lib/query/functions/core-values/chosen";
import { Routes } from "@/lib/router";
import { cx } from "@/lib/style/cva.config";
import { Button } from "../Global/Button";

export function ShareManifestWidget(props: React.ComponentPropsWithoutRef<"div">) {
	const { t } = useTranslation();

	const queryCoreValues = useQuery(queryOptions_coreValuesChosen());
	const hasChosenCoreValues = (queryCoreValues.data?.length ?? 0) >= CHOSEN_CORE_VALUES_LIMIT;

	if (!hasChosenCoreValues) {
		return <></>;
	}

	if (queryCoreValues.isLoading) {
		return <IonSkeletonText animated className="h-42 rounded-3xl" />;
	}

	return (
		<div
			{...props}
			className={cx("bg-brown-100 flex flex-col gap-2 rounded-3xl p-4", props.className)}
		>
			<div className="flex items-center justify-between">
				<IonText className="text-brown-700 text-2xl font-bold">
					{t("widgets.share-manifest.title")}
				</IonText>
			</div>

			<IonText className="text-brown-600">{t("widgets.share-manifest.description")}</IonText>

			<Button variant="primary" size="small" icon="arrow-right" routerLink={Routes.ShareManifest()}>
				{t("widgets.share-manifest.action")}
			</Button>
		</div>
	);
}
